import { Component, OnInit } from '@angular/core';
import { ScoringParametrage } from '../../core/model/ScoringParametrage';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ScoringParametreService } from '../../core/service/scoring-parametre.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from "rxjs/operators";

@Component({
  selector: "app-add-scoring-parametre",
  templateUrl: "./add-scoring-parametre.component.html",
  styleUrls: ["./add-scoring-parametre.component.scss"]
})
export class AddScoringParametreComponent implements OnInit {
  scoringParametrage: ScoringParametrage = new ScoringParametrage();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _scoringParametreService: ScoringParametreService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      libelle: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this.scoringParametrage = this.form2.value;
    this._scoringParametreService
      .add(this.scoringParametrage)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
